// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

import { createSelector } from 'reselect'

import { nextId, beatsByPosition, allBeatsAsArray } from '../helpers/beats'
import { fullFileStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').Beat} Beat
 * @typedef {import('../index').PlottrFileBeatsEntry} PlottrFileBeatsEntry
 * @typedef {import('../index').PlottrFileBeats} PlottrFileBeats
 */

/**
 * @type {function(PlottrState): PlottrFileBeats}
 */
export const allBeatsSelector = createSelector(fullFileStateSelector, (state) => state.beats)
/**
 * @type {function(PlottrState): number}
 */
export const nextBeatIdSelector = createSelector(allBeatsSelector, (beats) => nextId(beats))

/**
 * @type {function(PlottrState): Array<Beat>}
 */
export const allBeatsAsArraySelector = createSelector(allBeatsSelector, (beats) => {
  return allBeatsAsArray(beats)
})

/**
 * @type {function(PlottrState, number | 'series'): (number | 'series')}
 */
const bookIdSelector = (state, bookId) => bookId
/**
 * @type {function(PlottrState, number | 'series'): any}
 */
export const beatsForAnotherBookSelector = createSelector(
  bookIdSelector,
  allBeatsSelector,
  (bookId, beats) => {
    return beats[bookId]
  }
)

/**
 * @type {function(PlottrState): PlottrFileBeatsEntry}
 */
export const beatsForBookOne = createSelector(allBeatsSelector, (beats) => {
  return beats[1]
})

/**
 * @type {function(PlottrState, number | 'series'): Array<Beat>}
 */
export const sortedBeatsForAnotherBookSelector = createSelector(
  beatsForAnotherBookSelector,
  beatsByPosition(() => true)
)

const beatIdSelector = (_state, beatId) => {
  return beatId
}
/**
 * @type {function(PlottrState, number): (Beat | Null)}
 */
export const beatByIdSelector = createSelector(
  allBeatsSelector,
  beatIdSelector,
  (beatTrees, beatId) => {
    return Object.values(beatTrees).reduce((found, nextTree) => {
      if (found) {
        return found
      } else {
        return nextTree.index[beatId] || null
      }
    }, null)
  }
)
